var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { requestTranslateFunction } from '../utils/request-translate-function';
import { responseSchema } from './response-schema';
var ENDPOINT = '/ns/abac/suppliers-portal-core/v2/abac/features/get';
export var makeRequestConfig = function (_a) {
    var scope = _a.scope, attributes = _a.attributes, _b = _a.key, key = _b === void 0 ? null : _b, noRetry = _a.noRetry, ignoreResponseIdCompare = _a.ignoreResponseIdCompare, browserCacheParams = _a.browserCacheParams, _c = _a.featuresFilterList, featuresFilterList = _c === void 0 ? [] : _c, _d = _a.hideFalseFilteredFeatures, hideFalseFilteredFeatures = _d === void 0 ? false : _d;
    return {
        endpoint: ENDPOINT,
        body: {
            params: __assign({ scope: scope, attributes: attributes, key: key }, (featuresFilterList.length
                ? {
                    filter: {
                        features: featuresFilterList,
                        hideFalse: hideFalseFilteredFeatures,
                    },
                }
                : {})),
        },
        responseSchema: responseSchema,
        translateFunction: requestTranslateFunction,
        retry: noRetry ? 0 : 2,
        ignoreResponseIdCompare: ignoreResponseIdCompare,
        notRetryWhenOffline: true,
        browserCacheParams: browserCacheParams,
    };
};
